import { EXAM_CENTER_PROCTOR_REQUEST_ERROR_CODE_TO_FORM_ERROR } from './constants';

export function mapExamCenterProctorRecordErrorCodeToFormError(errorCodes: string[]) {
  return errorCodes
    .map((errorCode) => {
      return EXAM_CENTER_PROCTOR_REQUEST_ERROR_CODE_TO_FORM_ERROR[
        errorCode as keyof typeof EXAM_CENTER_PROCTOR_REQUEST_ERROR_CODE_TO_FORM_ERROR
      ];
    })
    .filter(Boolean);
}

export function mapFileFormInputToStorageObject<T extends { name: string; key: string }>(file: T) {
  return {
    originalFileName: file.name,
    uploadFileName: file.key,
  };
}

export function groupNewAndExistingFiles<T>(files: (File | T)[]) {
  const newFiles: File[] = [];
  const existingFiles: T[] = [];

  const fileArray = Array.isArray(files) ? files : [files];

  for (const file of fileArray) {
    if (file instanceof File) {
      newFiles.push(file);
      continue;
    }
    existingFiles.push(file);
  }

  return { newFiles, existingFiles };
}
